import {
  Home,
  BarChart2,
  LayoutDashboard,
  Users,
  Settings,
  FileText,
  ShoppingCart,
  Calendar,
  Bell,
  Map,
  ClipboardList,
  ClipboardCheck,
  Bug,
  DollarSign,
  AlertTriangle,
  Rocket,
  Wrench,
  Database,
  GitBranch,
  Shield,
  Zap,
  Package,
  type LucideIcon,
} from "lucide-react";

/** Registry of icons available for use in remotes.config.json.
 *  Add more lucide icon imports here as new remote apps are registered. */
export const iconRegistry: Record<string, LucideIcon> = {
  Home,
  BarChart2,
  LayoutDashboard,
  Users,
  Settings,
  FileText,
  ShoppingCart,
  Calendar,
  Bell,
  Map,
  ClipboardList,
  ClipboardCheck,
  Bug,
  DollarSign,
  AlertTriangle,
  Rocket,
  Wrench,
  Database,
  GitBranch,
  Shield,
  Zap,
  Package,
};

export { Home };
